import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const UpgradeModal = ({ open, onOpenChange, currentPlan, onUpgrade }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="modal-dark sm:max-w-2xl">
      <DialogHeader>
        <DialogTitle className="font-serif text-[#FDF8EE] flex items-center gap-2"><span className="text-[#E8A030]">◈</span> Upgrade Your Plan</DialogTitle>
      </DialogHeader>
      <div className="py-4 grid md:grid-cols-2 gap-4">
        <div className="border-2 border-[#E8A030] p-5 bg-[rgba(232,160,48,0.02)] relative">
          <div className="absolute -top-2.5 left-1/2 -translate-x-1/2">
            <span className="bg-[#E8A030] text-[#0A0600] font-mono text-[8px] font-bold px-2 py-0.5 uppercase tracking-[1px]">Popular</span>
          </div>
          <h4 className="font-serif font-bold text-[#FDF8EE] flex items-center gap-2">Signal <span className="text-[#E8A030]">◈</span></h4>
          <p className="font-mono text-[8px] text-[#4A3A1A] uppercase mb-3">For individuals</p>
          <p className="font-serif text-2xl font-bold text-[#FDF8EE] mb-1">$15<span className="text-sm font-normal text-[#4A3A1A] font-mono">/mo</span></p>
          <p className="font-mono text-[8px] text-[#4A3A1A] mb-4">or $144/year</p>
          <ul className="space-y-2 mb-4">
            {["Unlimited entries & volumes", "50 Ask Ryan queries per month", "Image attachments + OCR", "Notion sync", "Share volumes via link"].map((f, i) => (
              <li key={i} className="flex items-center gap-2 text-[11px] text-[#8C7A5A]"><span className="text-[#E8A030]">✓</span> {f}</li>
            ))}
          </ul>
          <button onClick={() => onUpgrade("signal_monthly")} className="btn-primary w-full" disabled={currentPlan === "signal_monthly"} data-testid="checkout-signal-btn">
            {currentPlan === "signal_monthly" ? "Current Plan" : "Get Signal →"}
          </button>
        </div>
        <div className="border border-[rgba(232,160,48,0.15)] p-5">
          <h4 className="font-serif font-bold text-[#FDF8EE] flex items-center gap-2">Synthesis <span className="text-[#A08CC8]">⬡</span></h4>
          <p className="font-mono text-[8px] text-[#4A3A1A] uppercase mb-3">For teams</p>
          <p className="font-serif text-2xl font-bold text-[#FDF8EE] mb-1">$24<span className="text-sm font-normal text-[#4A3A1A] font-mono">/user/mo</span></p>
          <p className="font-mono text-[8px] text-[#4A3A1A] mb-4">or $230/year per user</p>
          <ul className="space-y-2 mb-4">
            {["Everything in Signal", "150 Ask Ryan queries per user per month, pooled", "Shared volumes & collaborators", "Team knowledge base", "Admin dashboard + SAML SSO", "SLA & priority support"].map((f, i) => (
              <li key={i} className="flex items-center gap-2 text-[11px] text-[#8C7A5A]"><span className="text-[#A08CC8]">✓</span> {f}</li>
            ))}
          </ul>
          <button onClick={() => onUpgrade("synthesis_monthly")} className="btn-ghost w-full" disabled={currentPlan === "synthesis_monthly"} data-testid="checkout-synthesis-btn">
            {currentPlan === "synthesis_monthly" ? "Current Plan" : "Get Synthesis →"}
          </button>
        </div>
      </div>
      <p className="font-mono text-[9px] text-[#4A3A1A] text-center">Cancel anytime</p>
    </DialogContent>
  </Dialog>
);
